<ng-container *ngIf="platform === PlatformEnum.desktop; else touchContainer">
  <div class="desktop-container">
    <div
      *ngFor="
        let productConversionContainer of productConversionContainers;
        let i = index;
        trackBy: trackItem
      "
      class="product-conversion-row"
    >
      <div class="original-product-col">
        <p class="bold">{{ originalProductTitle | translate }}</p>
        <app-original-product-for-conversion
          [product]="productConversionContainer?.originalProduct"
          [platform]="platform"
          [pricingDisabled]="pricingDisabled"
          [showKeepProductButton]="showAcceptDeclineButtons"
          (keepProductEvent)="declineSwap(productConversionContainer)"
          (productImageClickEmitter)="handleProductImageClick($event, true)"
        ></app-original-product-for-conversion>
      </div>

      <div class="divider-col">
        <img src="assets/images/separator.png" />
      </div>

      <div class="replacement-product-col">
        <div class="replacement-top-row">
          <p>
            {{
              productConversionContainer?.replacementProduct?.reasonCode
                | translate
            }}
          </p>
          <div
            class="compare-icon"
            (click)="goToCompareProducts(productConversionContainer)"
          >
            <img
              data-cy="better-buy-card-compare-icon"
              src="assets/icon/Compare.svg"
            />
            {{ 'i18n.betterBuys.compare' | translate }}
          </div>
        </div>
        <app-replacement-product-for-conversion
          [product]="productConversionContainer?.replacementProduct"
          [platform]="platform"
          [pricingDisabled]="pricingDisabled"
          [isOnline]="isOnline"
          [showAcceptSwapButton]="showAcceptDeclineButtons"
          (changeQuantityEmitter)="
            changeQuantityHandler($event, productConversionContainer)
          "
          (acceptSwapEmitter)="acceptSwap(productConversionContainer)"
          (productImageClickEmitter)="handleProductImageClick($event, false)"
        ></app-replacement-product-for-conversion>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #touchContainer>
  <div class="touch-container">
    <div
      *ngFor="
        let productConversionContainer of productConversionContainers;
        let i = index;
        trackBy: trackItem
      "
      class="product-conversion-row"
      [class.mobile-conversion-row]="platform === PlatformEnum.mobile"
    >
      <div class="top-row">
        <p class="bold">{{ originalProductTitle | translate }}</p>
        <div
          *ngIf="platform === PlatformEnum.tablet"
          class="compare-icon"
          (click)="goToCompareProducts(productConversionContainer)"
        >
          <img
            data-cy="better-buy-card-compare-icon"
            src="assets/icon/Compare.svg"
          />
          {{ 'i18n.betterBuys.compare' | translate }}
        </div>
      </div>

      <div class="original-product-row">
        <app-original-product-for-conversion
          [product]="productConversionContainer?.originalProduct"
          [platform]="platform"
          [pricingDisabled]="pricingDisabled"
          [showKeepProductButton]="showAcceptDeclineButtons"
          (keepProductEvent)="declineSwap(productConversionContainer)"
          (productImageClickEmitter)="handleProductImageClick($event, true)"
        ></app-original-product-for-conversion>
      </div>

      <p class="bold reason-code">
        {{
          productConversionContainer?.replacementProduct?.reasonCode | translate
        }}
      </p>

      <div class="replacement-product-row">
        <app-replacement-product-for-conversion
          [product]="productConversionContainer?.replacementProduct"
          [platform]="platform"
          [pricingDisabled]="pricingDisabled"
          [isOnline]="isOnline"
          [showAcceptSwapButton]="showAcceptDeclineButtons"
          (changeQuantityEmitter)="
            changeQuantityHandler($event, productConversionContainer)
          "
          (acceptSwapEmitter)="acceptSwap(productConversionContainer)"
          (productImageClickEmitter)="handleProductImageClick($event, false)"
        ></app-replacement-product-for-conversion>
      </div>

      <div *ngIf="platform === PlatformEnum.mobile" class="compare-row">
        <div
          class="compare-icon"
          (click)="goToCompareProducts(productConversionContainer)"
        >
          <img
            data-cy="better-buy-card-compare-icon"
            src="assets/icon/Compare.svg"
          />
          {{ 'i18n.betterBuys.compare' | translate }}
        </div>
      </div>
    </div>
  </div>
</ng-template>
